import React from 'react';

import Image from './Image';
import Video from './Video';

export default function Illustration({ illustration }) {
  const file = illustration?.file?.file ? illustration?.file : illustration;
  const objectFit = illustration?.objectFit;
  const url = illustration?.url;

  return (
    <>
      {illustration && (
        <div className="illustration">
          {file && <Image file={file} objectFit={objectFit} />}
          {url && <Video url={url} />}
        </div>
      )}
    </>
  );
}
